import { render, staticRenderFns } from "./Pdtview.vue?vue&type=template&id=5a44e04e&"
import script from "./Pdtview.vue?vue&type=script&lang=js&"
export * from "./Pdtview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports